import { Box, Grid } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useParametrizationCurveStore from '@hook/parametrization/use-curve-store'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import TableGridScroll from '@component/Layout/TableGridScroll'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBarCurveStore from '@component/Parameterization/CurveStore/SelectedTableBar'

const ParametrizationCurveStore: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    data,
    setFilters,
    filename,
    params,
    pagination,
    filters,
    filtersList,
    currentyDate,
    clearAllFilters,
    total,
    pageCurrent,
    fetching,
    query,
    tableInteraction,
    actions,
    getData,
    getCenters,
    setFilename,
    handleUpdateParams
  } = useParametrizationCurveStore()

  const { hasSessions } = useSessions()
  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 225px)'
          : 'calc(100vh - 193px)'
        : hasSessions
        ? 'calc(100vh - 366px)'
        : 'calc(100vh - 334px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    getCenters()

    // data?.length === 0 && getData()
    getFilters({
      companies: true,
      centers: true,
      productManagers: true
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Grid templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}>
      {filters && (
        <LayoutFilters
          filters={filtersList}
          values={params}
          onChange={handleUpdateParams}
          loading={loading}
          canCancel={fetching}
          defaultDate={currentyDate}
          onFilter={() => getData(null, 1, 50, false)}
          onClearAllFilters={clearAllFilters}
          heightAll={'80vh'}
        />
      )}
      <Box>
        <LayoutTools
          title={filename}
          filters={filters}
          actions={actions}
          query={query}
          // onSearchChange={setQuery}
          onTitleChange={setFilename}
          toggleFilters={setFilters.toggle}
          isDisabled={loading || fetching || data.length === 0}
        />
        <SelectedTableBarCurveStore />

        {loading ? (
          <LayoutLoader
            title="Recuperando informações..."
            message="Aguarde enquanto buscamos os dados no banco de dados"
          />
        ) : data.length === 0 ? (
          <LayoutEmpty
            title="Nada encontrado!"
            message="Filtre sua busca ao lado para obter informações"
          />
        ) : (
          <Box>
            <Box paddingLeft={2}>
              <GridQuantity qtd={total.toString()} pagination={pagination} />
            </Box>

            <TableGridScroll
              id="parametrization-increment"
              headers={headers}
              query={query}
              data={data}
              entity="parametrization-increment"
              itsSortable={true}
              loading={fetching}
              actions={tableInteraction}
              height={tableHeight}
              pagination={pagination}
              getData={getData}
              total={total}
              pageCurrent={pageCurrent}
            />
          </Box>
        )}
      </Box>
    </Grid>
  )
}

export default ParametrizationCurveStore
